export enum TicketStatusId {
    New = 1,
    Assigned = 2,
    Completed = 3,
    Closed = 4,
    Rejected = 5
}